import React from "react";
import { Link } from "react-router-dom";
import CellWithIcon from "./CellWithIcon";

function CellWithLinkIcon({
    href = undefined,
    size = 20,
    className = undefined,
    type,
}) {
    const cellWithIcon = CellWithIcon(type, size);

    if (href !== undefined) {
        return (
            <Link to={href} className={className}>
                {cellWithIcon}
            </Link>
        );
    }

    return cellWithIcon;
}


export default CellWithLinkIcon;
